import { ExcelDownloadBtn } from "components/Buttons/ExcelDownloadBtn";
import { HTTP_METHOD, POST_MIGRATION_LIST } from "constants/pathConstant";
import { SWAP_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";
import { useExcelDownload } from "hooks/excelDownload/useExcelDownload";
import { useToastCustom } from "hooks/useToastCustom";
import { Info, List, Wrapper } from "template/ListTemplate.style";
import SwapInfoDetail from "./SwapInfoDetail";
import swapColumn from "./swapColumn.json";
import { useMutationCustom } from "hooks/useMutationCustom";
import PageHandler from "components/PageHandler/PageHandler";
import { xlsxDateFormat } from "components/xlsxDateFormat";
import { ListDefault } from "components/ListDefault/ListDefault";
import EmptyScreen from "components/EmptyScreen/EmptyScreen";

// 브릿지 -> 스왑 :: 스왑 신청/처리 목록 (http://localhost:3000/super/bridge/swap)
const SwapInfoList = ({
  setPage,
  setSize,
  swapList,
  searchData,
  setSwapList,
  isSearch,
}) => {
  const excelDownload = useExcelDownload();
  const toast = useToastCustom();

  const { mutate } = useMutationCustom(POST_MIGRATION_LIST, HTTP_METHOD.POST);
  // Excel 다운로드
  const handleExcelDownload = () => {
    if (!isSearch || !swapList.list[0]?.cnt) {
      toast("다운로드할 데이터가 없습니다", "error");
      return;
    }

    const researchCond = {
      ...searchData,
      pageSize: swapList.list[0]?.cnt,
      currentPage: 1,
    };

    mutate(researchCond, {
      onSuccess: (response) => {
        const updatedResponse = xlsxDateFormat(response.list);

        const excelData = {
          data: updatedResponse,
          headers: SWAP_XLSX_DOWNLOAD.header,
          fileName: SWAP_XLSX_DOWNLOAD.filename,
        };

        excelDownload(excelData);
      },

      onError: () => {
        toast("데이터 전체 조회 실패", "error");
      },
    });
  };

  return (
    <Wrapper>
      <List.TitleContainer>
        <List.TextContainer>
          <List.Text>스왑 내역</List.Text>
        </List.TextContainer>

        <List.BtnContainer>
          {/* 페이지 핸들러 */}
          <PageHandler setPage={setPage} setPageSize={setSize} />
          {/* 엑셀 다운로드 버튼 */}
          <ExcelDownloadBtn onClick={handleExcelDownload} />
        </List.BtnContainer>
      </List.TitleContainer>

      <List.Container>
        {!isSearch && <ListDefault text={"스왑 내역을"} />}
        {isSearch && !swapList.list.length && <EmptyScreen />}
        {isSearch && !!swapList.list.length && (
          <>
            <List.Content>
              {swapColumn.data.map((v, idx) => (
                <List.Row $ratio={v.ratio} key={idx}>
                  {v.title}
                </List.Row>
              ))}
            </List.Content>
            <Info.Wrapper>
              {swapList.list.map((v, idx) => (
                <SwapInfoDetail
                  data={v}
                  key={idx}
                  searchData={searchData}
                  setSwapList={setSwapList}
                />
              ))}
            </Info.Wrapper>
          </>
        )}
      </List.Container>
    </Wrapper>
  );
};

export default SwapInfoList;
